module.exports = __webpack_public_path__ + "static/media/profile-albums.4294cce5.png";


//////////////////
// WEBPACK FOOTER
// ./src/elements/screen-images/music/profile-albums.png
// module id = 716
// module chunks = 0